<template>
  <div class="about">
    <div class="bodyid">
      <div class="body">
        <div class="navbar">
          <div class="navbar-left">
            <img src="../assets/导航logo.png" />
<!--            <div class="left-line"></div>-->
            <span>｜企业微信开发服务商</span>
          </div>
          <div class="navbar-right">
            <span @click="url">微炬云首页</span>
<!--            <div class="right-line"></div>-->
            <span @click="urlHelp">帮助与文档</span>
            <div class="zixun">
<!--              <img class="zixun-img" src="../assets/咨询电话： 400-113-0200.png" alt="" />-->
              咨询电话：400-113-0200
            </div>
          </div>
        </div>
        <div class="imglogo">
          <div class="mm">
            <div class="denglu">
              <div class="toggle">
                <div @click="mima" :class="dispon == false ? 'abounh' : 'aboun'">
                  <div class="toggle-t">
                    <div class="juxing">账号密码登录</div>
                    <img src="../assets/账号登录.png" alt="" />
                  </div>
                  <div class="title-t">手机号码登录</div>
                </div>
                <div @click="yanzm" :class="dispon == true ? 'abounh' : 'aboun'">
                  <div class="toggle-t">
                    <div class="juxing">手机号码登录</div>
                    <img src="../assets/手机号码.png" alt="" />
                  </div>
                  <div class="title-t">微炬云登录</div>
                </div>
              </div>


              <!-- 账号登录 -->
              <el-form :model="ruleForm" pattern="^\d{11}$" :rules="rules" ref="ruleForm" class="demo-ruleForm"
                v-if="dispon">
                <el-form-item prop="username" key="username">
                  <el-input v-model="ruleForm.username" placeholder="微炬云登录账号" >
                    <i slot="prefix" class="el-input__icon"><img src="../assets/登录账号.png" alt=""></i>
                  </el-input>
                </el-form-item>
                <el-form-item prop="password" key="password">
                  <el-input type="password" v-model="ruleForm.password" placeholder="登录密码">
                    <i slot="prefix" class="el-input__icon"><img src="../assets/icon密码.png" alt=""></i>
                  </el-input>
                </el-form-item>
                <!--验证码组件-->
                <div class="yzCode">
                  <el-form-item prop="yzm" id="yzmk" maxlength="4">
                    <el-input style="width: 22.0rem;" v-on:keyup.enter="keyLogin" v-model="ruleForm.yzm"
                      placeholder="请填写验证码">
                      <i slot="prefix" class="el-input__icon"><img src="../assets/验证码.png" alt=""></i>
                    </el-input>
                  </el-form-item>
                  <div class="login-code" @click="abcou" v-if="dispon">
                    <!-- 验证码组件 -->
                    <img :src="imgCode" class="sson" />
                  </div>
                </div>
<!--                <el-form-item style="margin-top: 3.0rem;">-->
<!--                  <el-button class="loginBtn" @click="submitForm('ruleForm')">登录</el-button>-->
<!--                </el-form-item>-->
<!--                <el-form-item>-->
<!--                  <el-button class="loginBtn" @click="codeLogin">扫码登录</el-button>-->
<!--                </el-form-item>-->
                <div class="login">
                  <el-button class="loginBtn" @click="submitForm('ruleForm')">登录</el-button>
                  <el-button class="loginBtn" @click="codeLogin">扫码登录</el-button>
                </div>
              </el-form>
              <!-- 手机号登录 -->
              <el-form center :model="ruleForm" :rules="rules" ref="ruleForm"
                class="demo-ruleForm" v-if="!dispon">
                <el-form-item prop="username" pattern="^\d{11}$">
                  <el-input v-model="ruleForm.username" placeholder="请输入手机号">
                    <i slot="prefix" class="el-input__icon"><img src="../assets/iconphone.png" alt=""></i>
                  </el-input>
                </el-form-item>
                <el-form-item id="aa" prop="sms" key="sms" pattern="^\d{6}$">
                  <el-input v-model="ruleForm.sms" style="width: 62%;" placeholder="请输入短信验证码">
                    <i slot="prefix" class="el-input__icon"><img src="../assets/验证码.png" alt=""></i>
                  </el-input>
                  <el-button @click.prevent="btnClick" :disabled="yzAble" id="inpbtn" class="yzBtn">{{ btntitle }}</el-button>
                </el-form-item>
                <div class="login">
                  <el-button class="loginBtn" @click="onSubmit">登录</el-button>
                  <el-button class="loginBtn" @click="codeLogin">扫码登录</el-button>
                </div>
              </el-form>
              <div class="monee">
                <div class="monee-l">
                  <span>还没有账号？</span>
                  <span @click="aa()">免费注册</span>
                </div>
                <el-button id="mimazhaohui" type="text" @click="zmm">忘记密码？</el-button>
              </div>
            </div>
          </div>
        </div>
<!--        <div class="footer">-->
<!--          <div class="footer-t">-->
<!--            <ul>-->
<!--              <li>-->
<!--                <a href="https://www.weijub.com/index/index/index">首页</a>-->
<!--              </li>-->
<!--              <li>|</li>-->
<!--              <li>-->
<!--                <a href="https://www.weijub.com/index/index/product">微炬云产品</a>-->
<!--              </li>-->
<!--              <li>|</li>-->
<!--              <li>-->
<!--                <a href="https://www.weijub.com/index/index/plan">行业解决方案</a>-->
<!--              </li>-->
<!--              <li>|</li>-->
<!--              <li>-->
<!--                <a href="https://www.weijub.com/index/index/channel">渠道合作</a>-->
<!--              </li>-->
<!--              <li>|</li>-->
<!--              <li>-->
<!--                <a href="https://www.weijub.com/index/index/news?category_id=15">营销干货</a>-->
<!--              </li>-->
<!--              <li>|</li>-->
<!--              <li>-->
<!--                <a href="https://www.weijub.com/index/index/channel_center">渠道中心</a>-->
<!--              </li>-->
<!--              <li>|</li>-->
<!--              <li>-->
<!--                <a href="https://www.weijub.com/index/index/about">关于我们</a>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--          <div class="footer-b">-->
<!--            Copyright © 2013-2023 www.weijub.com All Rights Reserved-->
<!--            上海微炬云企业发展有限公司版权所有 沪ICP备20021369号-1-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <el-dialog title="选择账号" center :visible.sync="choice" width="40%">
      <!-- <el-button type="primary" v-for="(item,index) in res" :key="index" @click="select(item)"> {{item.account_name}} </el-button> -->
      <div class="qiye" v-for="(item, index) in res" :key="index" @click="select(item)">
        <div class="imgs" v-if="item.enterprisePhoto">
          <el-image style="width: 100%; height: 5.0rem" :src="item.enterprisePhoto" fit="scale-down"></el-image>
        </div>
        <div v-else class="imgs">
          {{ item.account_name }}
        </div>
        <div class="phonename">{{ item.account_name }}</div>
      </div>
    </el-dialog>
    <el-dialog title="请输入当前企业的密码" center :visible.sync="passwordtow" width="40%">
      <el-form label-width="8.0rem">
        <el-form-item label="密码">
          <el-input clearable v-model="ruleForm.password" show-password></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passwordtow = false">取 消</el-button>
        <el-button type="primary" @click="(passwordtow = false), enterss()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Toast } from "vant";
import Vue from "vue";
import { Area } from "vant";
import areaList from "../data/area.js";
import qs from "qs";
import md5 from "js-md5";
import logopath from "../filter/logopath.js";
import { provinceAndCityData, CodeToText } from "element-china-area-data";

export default {
  data() {
    return {
      yzAble:false,//发送验证码的可用状态
      username: "", //账号sms
      password: "", //密码
      yzm: "",// 输入框中的验证码
      pattern:
        /(^([0-9]{3,4}-)?[0-9]{7,8}$)|(^((\(\d{3}\))|(\d{3}\-))?(1[3456789]\d{9})$)/, //手机正则
      btntitle: "获取验证码",
      // btntitle: "获取验证码",
      imgCode: "https://api.weijub.com/api/user/newCode",
      cansend: true,
      timer: null,
      userdetailShow: false,
      yam: "", // 短信获取到的验证码
      sms: "", //输入框中短信验证码
      usernamee: "",
      smsm: "",
      passworde: "",
      passwordee: "",
      dispon: true,
      dialogFormVisible: false,
      aaa: "",
      ruleForm: {
        sjs: "",
        username: "",
        password: "",
        yzm: "",
        sms: ""
      },
      account_id: "",
      choice: false,
      res: [],
      passwordtow: false,
      checked: true,
      activeIcon: require("../assets/activeIcon.png"),
      inactiveIcon: require("../assets/inactiveIcon.png"),
      public_account_id: "",
      auth_code: "",
      rules: {
        username: [
          {

            required: true,
            message: '微炬云账号不能为空',
            trigger: 'blur'
          },
          {
            required: true,
            min: 11, max: 11,
            message: '微炬云账号格式不正确',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '密码不能为空',
            trigger: 'blur'
          },
          {
            min: 6,
            message: '密码格式错误',
            required: true,
            trigger: 'blur'
          }
        ],
        yzm: [
          {
            required: true,
            message: '请输入验证码并与验证码保持一致',
            trigger: 'blur'
          }

        ],

        sms: [

          {
            required: true,
            message: '请输入验证码并与验证码保持一致',
            trigger: 'blur'
          }
        ],

      },

      // pattern: /(^([0-9]{3,4}-)?[0-9]{7,8}$)|(^((\(\d{3}\))|(\d{3}\-))?(1[3456789]\d{9})$)/,
    };
  },

  destroyed() {
    //取消键盘监听事件
    document.onkeydown = null
  },
  mounted() {
    this.keyLogin()
    // console.log(this.$route.query.public_account_id);
    this.abcou();
    this.get_qruserinfo();
    // 微盟跳转授权
    const public_account_id = this.$route.query.public_account_id;
    if (public_account_id) {
      localStorage.setItem("public_account_id", public_account_id);
      this.public_account_id = public_account_id;
    } else {
      const public_account_id_storage =
        localStorage.getItem("public_account_id");
      if (public_account_id_storage) {
        this.public_account_id = public_account_id_storage;
      }
    }

    // 企业微信跳转授权
    let q = {};
    try {
      let href = location.href.split("?")[1];
      href = href.split("#")[0];
      q = qs.parse(href);
    } catch (error) {
      console.log(error);
    }

    const auth_code = q.auth_code;
    if (auth_code) {
      localStorage.setItem("auth_code", auth_code);
      this.auth_code = auth_code;
    } else {
      const auth_code_storage = localStorage.getItem("auth_code");
      console.log(auth_code_storage);
      if (auth_code_storage) {
        this.auth_code = auth_code_storage;
      }
    }
    if (localStorage.getItem("title")) {
      let title = JSON.parse(localStorage.getItem("title"));
      this.title = title;
      var a = document.title;
      document.title = title[0].website + "-" + a;
    }
    this.abcou();
  },
  methods: {
    //element 验证
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.onSubmit();

        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    url() {
      location.href = "https://www.weijub.com";
    },
    aa() {
      this.$router.push("/reg");
    },
    zmm() {
      this.$router.push("/zhmm");
    },
    urlHelp() {
      location.href = "https://www.weijub.com/index/index/help.html?id=59";
    },
    abcou() {
      this.ruleForm.sjs = Math.round(Math.random() * 100000000);
      var obj = this.ruleForm.sjs;
      this.imgCode = "https://api.weijub.com/api/user/newCode?id=" + obj + "";
    },
    select(item) {
      this.account_id = item.account_id;
      if (this.dispon) {
        this.enterss();
      } else {
        this.yanzhen();
      }
    },
    ones() {
      this.abcou();
      if (this.passworde !== this.passwordee) {
        this.$message.error("两次密码不一致");
        return;
      }
      this.axios
        .post(
          "/api/user/changeUserPassword", //必须导入qs 加上qs.styingify
          qs.stringify({
            phone: this.usernamee, //账号
            password: this.$md5(this.passworde), //密码
            code: this.ruleForm.sms,
          }),
          // form表单提交方式
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            var Storuser = res.data.data;
            localStroage.setItem("storuser", JSON.stringify(Storuser));
            this.abcou();
            this.dialogFormVisible = false;
          } else {
            this.$message.error(res.data.msg);
            this.dialogFormVisible = true;
          }
        })
        .catch(function (error) { });
    },
    mima() {
      this.dispon = true;
    },
    yanzm() {
      this.dispon = false;
    },

    inputPassword() {
      if (this.passworde != this.passwordee) {
        Toast("请与密码保持一致");
        return;
      }
    },
    // 获取用户的会话系统的参数列表
    getParams(id, token, phone) {
      this.axios({
        method: "post",
        url: `/home/AccountInfo/getAccountInfo`,
        data: qs.stringify({
          auth_code: this.auth_code,
          account_id: id,
          usertoken: token,
          phone,
        }),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((res) => {
          window.localStorage.setItem("account_id", id);
          window.localStorage.setItem("phone", phone);
          if (res.data.code === 0) {
            this.$router.push({
              name: "authorization",
              query: { url: this.aaa },
            });
          } else if (res.data.code === 1) {
            this.$router.push("/register/user/dataTotal");
          }
        })
        .catch((err) => { });
    },
    enter() {
      this.axios
        .post(
          "/api/user/userLogin", //必须导入qs 加上qs.styingify
          qs.stringify({
            phone: this.ruleForm.username, //账号
            password: this.$md5(this.ruleForm.password), //密码
            account_id: this.account_id,
            public_account_id: this.public_account_id,
            auth_code: this.auth_code,
          }),
          // form表单提交方式
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((response) => {
          Toast(response.data.msg);
          let localStroage = window.localStorage;
          localStroage.setItem("usertoken", response.data.data.usertoken);
          localStroage.setItem("id", response.data.data.id);
          localStroage.setItem("phone", response.data.data.phone);
          localStroage.setItem("returnUrl", response.data.data.returnUrl);
          if (response.data.code == 1) {
            // 获取用户的会话系统的参数信息
            if (response.data.data.role_id === 0) {
              this.getParams(
                response.data.data.id,
                response.data.data.usertoken,
                response.data.data.phone
              );
            } else if (response.data.data.role_id !== 0) {
              this.$router.replace("register/user/dataTotal");
            }
            var storuser = response.data.data;
            localStroage.setItem("storuser", JSON.stringify(storuser));
          } else {
            this.abcou();
          }
        })
        .catch(function (error) { });
    },
    enterss() {
      this.axios
        .post(
          "/api/user/userLogin", //必须导入qs 加上qs.styingify
          qs.stringify({
            phone: this.ruleForm.username, //账号
            password: this.$md5(this.ruleForm.password), //密码
            account_id: this.account_id,
            public_account_id: this.public_account_id,
            auth_code: this.auth_code,
          }),
          // form表单提交方式
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((response) => {
          // console.log(response);
          // Toast(response.data.msg);
          if (response.data.code == 1) {
            this.$message({
              message: response.data.msg,
              type: "success",
            });
          }
          if (response.data.code == 0) {
            this.$message.error(response.data.msg);
            this.passwordtow = true;
          }
          let localStroage = window.localStorage;
          localStroage.setItem("usertoken", response.data.data.usertoken);
          localStroage.setItem("id", response.data.data.id);
          localStroage.setItem("phone", response.data.data.phone);
          localStroage.setItem("returnUrl", response.data.data.returnUrl);
          if (response.data.code == 1) {
            // 获取用户的会话系统的参数信息
            if (response.data.data.role_id === 0) {
              this.getParams(
                response.data.data.id,
                response.data.data.usertoken,
                response.data.data.phone
              );
            } else if (response.data.data.role_id !== 0) {
              this.$router.replace("register/user/dataTotal");
            }
            var storuser = response.data.data;
            localStroage.setItem("storuser", JSON.stringify(storuser));
          } else {
            this.abcou();
          }
        })
        .catch(function (error) { });
    },
    keyLogin() {
      var _this = this;
      document.onkeydown = function (e) {   //按下回车提交
        let key = window.event.keyCode;
        //事件中keycode=13为回车事件
        if (key == 13) {
          _this.onSubmit();
        }
      };
    },
    onSubmit(values) {

      if (this.dispon) {
        this.axios
          .post(
            "/api/user/verfycode",
            qs.stringify({
              code: this.ruleForm.yzm,
              id: this.ruleForm.sjs,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.code == 1) {
              //登录 账号密码 登录
              this.axios
                .post(
                  "/crm/UserAccount/getCompanyLists",
                  qs.stringify({
                    phone: this.ruleForm.username,
                  }),
                  {
                    headers: {
                      "Content-Type": "application/x-www-form-urlencoded",
                    },
                  }
                )
                .then((res) => {
                  if (res.data.count == 1 || res.data.code == 0) {
                    if (res.data.code == 0) {
                      this.$message.error(res.data.msg);
                      return;
                    }
                    this.account_id = res.data.data[0].account_id;
                    this.enter();
                  } else if (res.data.count == 5) {
                    this.account_id = res.data.data.account_id;
                    this.enter();
                  } else {
                    this.choice = true;
                    this.res = res.data.data;
                  }
                })
                .catch(function (err) { });
            } else {
              Toast(res.data.msg);
              this.abcou();
            }
          })
          .catch(function (err) { });
      } else {
        // if (this.yam != this.ruleForm.sms) {
        //   this.$message.error("短信验证码错误");
        //   return;
        // }
        // 验证码登录
        this.axios
          .post(
            "/crm/UserAccount/getCompanyLists",
            qs.stringify({
              phone: this.ruleForm.username,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.count == 1 || res.data.code == 0) {
              if (res.data.code == 0) {
                this.$message.error(res.data.msg);
                return;
              }
              this.account_id = res.data.data[0].account_id;
              this.yanzhen();
            } else if (res.data.count == 5) {
              this.account_id = res.data.data.account_id;
              this.enter();
            } else {
              this.choice = true;
              this.res = res.data.data;
            }
          })
          .catch(function (err) { });
      }
    },
    yanzhen() {
      this.axios
        .post(
          "/api/user/sendPhoneLogin", //必须导入qs 加上qs.styingify
          qs.stringify({
            phone: this.ruleForm.username, //账号
            account_id: this.account_id,
            code: this.ruleForm.sms,
            public_account_id: this.public_account_id,
            auth_code: this.auth_code,
          }),
          // form表单提交方式
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((response) => {
          if (response.data.code == 1) {
            this.$message({
              message: response.data.msg,
              type: "success",
            });
          }
          if (response.data.code == 0) {
            this.$message.error(response.data.msg);
            this.passwordtow = true;
          }
          let localStroage = window.localStorage;
          localStroage.setItem("usertoken", response.data.data.usertoken);
          localStroage.setItem("id", response.data.data.id);
          localStroage.setItem("phone", response.data.data.phone);
          localStroage.setItem("returnUrl", response.data.data.returnUrl);
          if (response.data.code == 1) {
            // 获取用户的会话系统的参数信息
            if (response.data.data.role_id === 0) {
              this.getParams(
                response.data.data.id,
                response.data.data.usertoken,
                response.data.data.phone
              );
            }
            this.aaa = response.data.data;
            var storuser = response.data.data;
            localStroage.setItem("storuser", JSON.stringify(storuser));
            if (response.data.data.role_id !== 0) {
              this.$router.replace("register/user/dataTotal");
            }
          }
        })
        .catch(function (error) { });
    },
    btnClickne() {
      if (this.usernamee == "") {
        Toast("手机号码格式不能为空");
      } else {
        if (this.cansend) {
          this.cansend = false;
          // 发送请求
          this.axios
            .post(
              "/api/user/sendtel", //必须导入qs 加上qs.styingify
              qs.stringify({
                tel: this.usernamee,
                status: "2",
              }),
              // form表单提交方式
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((response) => {
              this.yam = response.data.data;
            })
            .catch(function (error) { });
          // 倒计时

          let countdown = 30;
          this.btntitle = countdown + "秒后重新发送";
          this.timer = setInterval(() => {
            countdown--;
            if (countdown <= 0) {
              clearInterval(this.timer);
              this.timer = null;
              this.btntitle = "重新发送";
              this.cansend = true;
            } else {
              this.btntitle = countdown + "秒后重新发送";
            }
          }, 1000);
        }
      }
    },
    btnClick() {
      if (this.ruleForm.username == "") {
        Toast("手机号码格式不能为空");
      } else {
        this.cansend = false;
        this.yzAble=true
        // 发送请求
        this.axios
          .post(
            "/api/user/sendtel", //必须导入qs 加上qs.styingify
            qs.stringify({
              tel: this.ruleForm.username,
              status: "4",
            }),
            // form表单提交方式
            {
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
            }
          )
          .then((response) => {
            this.yam = response.data.data;
          })
          .catch(function (error) { });
        // 倒计时

        let countdown = 30;
        this.btntitle = countdown + "秒后重新发送";
        this.timer = setInterval(() => {
          countdown--;
          if (countdown <= 0) {
            clearInterval(this.timer);
            this.yzAble=false
            this.timer = null;
            this.btntitle = "重新发送";
            this.cansend = true;
          } else {
            this.yzAble=true
            this.btntitle = countdown + "秒后重新发送";
          }
        }, 1000);
      }
    },
    codeLogin() {
      location.href =
        "https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=ww046b9da236593b36&redirect_uri=https%3A%2F%2Fwork.weijub.com%2F%23%2Fregister&state=zfh&usertype=member";
    },
    get_qruserinfo() {
      // const url = "https://work.weijub.com/#/register?auth_code=yQ0lZd9wszMMFZhIMrp6q6tnup5Ti19NvHqG8vyMwZuGbaDcfc63YFSlGUvgugsQ2ym0W9l0AmT3C_ZpJaOdxIbJrA3y6_9OaUXElcLre1k"
      // console.log(url.indexOf("#"))  //24
      // const url = "https://work.weijub.com/?auth_code=yQ0lZd9wszMMFZhIMrp6q6tnup5Ti19NvHqG8vyMwZuGbaDcfc63YFSlGUvgugsQ2ym0W9l0AmT3C_ZpJaOdxIbJrA3y6_9OaUXElcLre1k#/register"
      // console.log(url.indexOf("#"))  //142

      const url = location.href;
      let num = url.indexOf("#");
      let auth_code;

      if (url.includes("auth_code")) {
        if (num < 30) {
          auth_code = this.$route.query.auth_code;
        } else {
          const params = url.split("=")[1];
          const last_location = params.indexOf("#"); // 知道#的位置
          const params1 = params.substr(0, last_location);
          auth_code = params1;
        }
      }

      console.log(auth_code);

      let public_account_id = localStorage.getItem("public_account_id");

      if (auth_code) {
        this.axios
          .post(
            "/crm/index/get_qruserinfo3",
            qs.stringify({
              auth_code: auth_code,
              public_account_id: public_account_id,
            }),
            {
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
            }
          )
          .then((response) => {
            Toast(response.data.msg);
            if (response.data.code == 1) {
              let localStorage = window.localStorage;
              localStorage.setItem("account_id", response.data.data.account_id);
              localStorage.setItem("usertoken", response.data.data.usertoken);
              localStorage.setItem("id", response.data.data.id);
              localStorage.setItem("phone", response.data.data.phone);
              localStorage.setItem("returnUrl", response.data.data.returnUrl);
              let storuser = response.data.data;
              localStorage.setItem(
                "storuser",
                JSON.stringify(storuser)
              );
              // 获取用户的会话系统的参数信息
              if (response.data.data.role_id === 0) {
                this.getParams(
                  response.data.data.id,
                  response.data.data.usertoken,
                  response.data.data.phone
                );
              } else if (response.data.data.role_id !== 0) {
                this.$router.replace("register/user/dataTotal");
              }
            } else if (response.data.code == 88) {
              location.href = "https://work.weijub.com/#/authorization?url=";
            } else {
              this.abcou();
            }
          })
          .catch(function (err) {
            console.log(err);
          });
      }
    },
  },
};
</script>
<style  scoped>
::v-deep.van-cell {
  display: flex;
  box-sizing: border-box;
  width: 34.0rem;
  margin: 2.0rem auto 0;
  padding: 1.2rem 1.6rem;
  overflow: hidden;
  color: rgba(0, 33, 105, 0.3);
  font-size: 1.4rem;
  background-color: #fff;
  border: .1rem solid rgba(0, 33, 105, 0.2);
}
</style>
<style lang="scss" scoped>


//.yzBtn {
//  display: inline-block;
//  position: relative;
//  bottom: 5.0rem;
//  left: 18.1rem;
//}

.yzCode {
  display: flex;
  align-items: center;
}

.root {
  width: 100%;
  height: 100%;
}

.about {
  width: 100%;
  height: 100%;
}

h1 {
  text-align: center;
}

.bodynav {
  margin-top: 2em;
  margin-bottom: 2em;
}

.bodynav>h1 {
  text-align: center;
}

.title {
  width: 100%;
  height: 8%;
}

#inpbtn {
  //width: 19.0rem;
  height: 7.0rem;
  box-shadow: .0rem .4rem 1.6rem .0rem rgba(98,128,103,0.2);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #49B372;
  font-size: 2.2rem;
  line-height: 3.0rem;
  position: fixed;
  right: 12.4rem;
  //top: .3rem;
  //left: -7.8rem;
  padding: 2.0rem !important;
  border: 0;
  border-radius: 1.0rem;
}

.bodyid {
  width: 100%;
  height: 100%;
}

.nav-left {
  display: inline-block;
  position: relative;
  top: 30%;
  left: 11.41%;
}

.nav-left>ul>li {
  color: #48a3e3;
  font-size: 3em;
}

.nav-right {
  float: right;
  margin-top: 0.7%;
}

.nav-right>ul {
  display: flex;
  width: 40.0rem;
  justify-content: space-around;
}

.nav-right>ul>li>a:hover {
  color: #48a3e3;
}

.nav-right>ul>li:nth-child(4) {
  border-right: .0rem;
}

.nav-right>ul>li>img {
  display: inline-block;
  width: 2.0rem;
  height: 2.0rem;
}

.nav-right>ul>li>a {
  display: inline-block;
  bottom: 4%;
  color: #666666;
}

.nav-left>span {
  margin-top: 20%;
}

.zixun {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 12.0rem;
  height: 6.0rem;
  background: #2b6dff;
}

.zixun-img {
  width: 8.1rem;
  height: 3.0rem;
}

.body {
  //width: 100%;
  height: 100%;
  background-image: url("../assets/背景.png");
  background-size: 100% 100%;
}

.navbar {
  width: 100%;
  height: 6.0rem;
  padding: 2.4rem 5.0rem 0;
  color: #333;
  display: flex;
  justify-content: space-between;
}

.navbar-left {
  display: flex;
  align-items: center;
  line-height: 1;
}

.navbar-left>img {
  width: 21.0rem;
  height: 2.9rem;
}


.navbar-left>span {
  display: block;
  font-size: 1.2rem;
  margin-left: 3.0rem;
}

.navbar-right {
  display: flex;
  align-items: center;
  line-height: 1;
}

.navbar-right>span {
  display: block;
  font-size: 1.6rem;
  cursor: pointer;
  margin-right: 5.0rem;
}

.zixun{
  width: 22.2rem;
  height: 3.2rem;
  color: #fff;
  font-size: 1.6rem;
  background-color: #49B372;
}

.imglogo {
  display: flex;
  justify-content: flex-end;
padding-right: 11.0rem;
  height: auto;
}

.mm {
  margin-top: 9.0rem;

}

.denglu {
  width: 75.0rem;
  height: 70.0rem;
  background: rgba(255,255,255,0.7);
  box-shadow: .0rem .2rem 2.0rem -.3rem rgba(0,0,0,0.2);
  border-radius: 2.0rem;
  backdrop-filter: blur(1.0rem);
}

.toggle {
  width: 100%;
  height: 17.7rem;
  padding-left: 12.5rem;
}

.toggle-t {
  display: flex;
  justify-content: flex-end;
  //margin-bottom: 1.8rem;
}

.toggle-t>img {
  width: 10.0rem;
  height: 10.0rem;
}

.juxing {
  width: 13.8rem;
  height: 4.0rem;
  background-image: url("../assets/矩形11.png");
  background-size: 100% 100%;
  font-size: 1.8rem;
  line-height: 4.0rem;
  text-align: center;
  margin: 3.0rem 0 0;
  position: relative;
  left: 3.0rem;
  color: #49B372;
}

.abounh {
  width: 100%;
  height: 10.3rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #2b6dff;
}

.aboun {
  display: none;
}

.title-t {
  font-size: 4.2rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: #333333;
  display: flex;
  align-items: center;
  letter-spacing: .8rem;
}
.title-t::before{
  display: inline-block;
  content: '';
  width: 1.0rem;
  height: 4.0rem;
  border-radius: .9rem;
  background: #49B372;
  margin-right: .9rem;
}
.el-input__icon{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.0rem;
  height: 3.0rem;
}

.el-input__icon img{
  width: 3.0rem;
  height: 3.0rem;
}
::v-deep .el-input__prefix{
  left: 3.0rem;
  top: 2.0rem;
}
::v-deep .el-input__inner{
  &::placeholder{
    font-size: 2.2rem;
    letter-spacing: .1rem;
  }
}
.sson {
  width: 15.0rem;
  height: 7.0rem;
}

.footer-t {
  color: #666666;
  font-size: 1.4rem;
}

.footer-t ul li a {
  color: #666;
}

.footer-t>ul {
  width: 75.0rem;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.footer-b {
  color: #333333;
  font-size: 1.2rem;
  text-align: center;
  margin-top: 1.0rem;
}

.denglu .img-icon {
  width: 1.5rem;
  height: 1.5rem;
}

.denglu>h1 {
  font-size: 2.8rem;
  color: #2b57ac;
  margin-bottom: 2.0rem;
  font-weight: 500;
}

.denglu>span {
  font-size: 2.2rem;
  /* color: #ffffff; */
  cursor: pointer;
}

.denglu>span:nth-child(1) {
  display: inline-block;
  width: 20.5rem;
  padding: 0 0 1.8rem;
  text-align: center;
  margin-left: 1.8rem;
}

.denglu>span:nth-child(2) {
  display: inline-block;
  width: 20.5rem;
  padding: 0 0 1.8rem;
  text-align: center;
  float: right;
  /* margin-right: 1.8rem; */
}

.jizhumima {
  float: left;
  margin: 2.0rem 0 2.0rem 2.0rem;
}

::v-deep.jizhumima .van-checkbox__label {
  color: #969799;
}

.van-form {
  width: 100%;
}

.monee {
  width: 50.0rem;
  height: 2.8rem;
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: center;
  margin: 0 auto;
  line-height: 2.5rem;
  font-size: 1.8rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #080A44;
  line-height: 2.8rem;
  margin-top: -1.0rem;
}

.monee-l>span {
  color: #080a44;
}

.monee-l>span:nth-child(2) {
  color: #49B372;
  cursor: pointer;
}

#mimazhaohui {
  padding: 0 !important;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #49B372 !important;
  line-height: 2.8rem;
  font-size:  1.8rem !important;
}


.qiye {
  width: 35.0rem;
  /* height: 20.0rem; */
  /* background-color: red; */
  margin: 0 auto;
  border-radius: .3rem;
  border: .1rem solid rgb(234, 235, 238);
  margin-top: 1.0rem;
  cursor: pointer;
}

.imgs {
  width: 100%;
  padding: 2.0rem;
  color: rgb(54, 96, 141);
  font-size: 2.5rem;
  text-align: center;
  font-weight: 900;
}

.phonename {
  width: 100%;
  padding: 1.0rem;
  background-color: rgb(241, 244, 246);
  text-align: center;
  font-size: 2.2rem;
}

.imgs img {
  width: 100%;
  height: 5.0rem;
}

.dialog-footer .sure {
  color: #fff;
  background: #12baf3;
}

.demo-ruleForm {
  padding-left: 12.5rem;
}
::v-deep .el-input--prefix .el-input__inner{
  padding-left: 9.0rem;
}
::v-deep .el-input__inner{
  background: #fff;
}
#aa>>>.el-form-item__content {
  width: 22.0rem;
  height: 6.0rem;
  background: #FFFFFF;
  border: .1rem solid rgba(0, 33, 105, 0.2);
}

.login-code {
  width: 18.0rem;
  height: 7.0rem;
  z-index: 10;
  position: relative;
  top: -1.5rem;
  left: 13.0rem;
  box-shadow: -.5rem .0rem 1.4rem -.9rem rgba(152,152,152,0.5);
}
::v-deep .el-form-item {
  margin-bottom: 3.0rem;
}

.demo-ruleForm el-form-item {
  height: 7.0rem;
  background: #FFFFFF;
  border: .1rem solid rgba(0, 33, 105, 0.2);
}

.demo-ruleForm #yamk {
  width: 22.0rem;
  height: 7.0rem;
  background: #FFFFFF;
  border: .1rem solid rgba(0, 33, 105, 0.2);
}

::v-deep .el-form-item__content .el-input input {
  width: 50.0rem;
  height: 7.0rem;
  box-shadow: .0rem .4rem 1.6rem .0rem rgba(98,128,108,0.2);
  border-radius: 1.0rem;
  border: none;
}

::v-deep .el-form-item__content .el-button {
  font-size: 1.8rem;
}
.login{
  width: 50.0rem;
  display: flex;
  justify-content: space-between;
  margin: 3.0rem 0 2.0rem;
  .loginBtn{
    width: 22.0rem;
    height: 7.0rem;
    color:#fff;
    font-size: 2.2rem;
    background: #49B372 linear-gradient(136deg, rgba(255,255,255,0.1) 0%, #3A3C 100%);
    box-shadow: .0rem .7rem 1.0rem .0rem rgba(73,179,114,0.5), .0rem -.7rem 1.0rem .0rem rgba(255,255,255,0.5);
    border-radius: 1.0rem;
    border: none;
  }
  .loginBtn:hover,.loginBtn:focus{
    color: #fff !important;
    background: #49B372 linear-gradient(136deg, rgba(255,255,255,0.1) 0%, #3A3C 100%) !important;
  }
}
.footer {
  margin-top: 12.5rem;
}
</style>
